export interface NotificationBodyContent {
  message: string;
  imageUrl?: string;
  imageData?: string;
  videoUrl?: string;
  videoData?: string;
  linkUrl?: string;
}

const SERIALIZED_VERSION = 1;

export const parseNotificationBody = (body?: string | null): NotificationBodyContent => {
  if (!body) {
    return { message: '' };
  }

  try {
    const parsed = JSON.parse(body);
    if (
      parsed &&
      typeof parsed === 'object' &&
      parsed.version === SERIALIZED_VERSION &&
      typeof parsed.message === 'string'
    ) {
      const content: NotificationBodyContent = {
        message: parsed.message,
        imageUrl: parsed.imageUrl || undefined,
        imageData: parsed.imageData || undefined,
        videoUrl: parsed.videoUrl || undefined,
        videoData: parsed.videoData || undefined,
        linkUrl: parsed.linkUrl || undefined,
      };
      return content;
    }
  } catch (error) {
    // ignore parsing errors and fall back to treating the body as plain text
  }

  return { message: body };
};

export const serializeNotificationBody = (content: NotificationBodyContent): string => {
  const payload: any = {
    version: SERIALIZED_VERSION,
    message: content.message,
  };

  if (content.imageUrl) {
    payload.imageUrl = content.imageUrl;
  }
  if (content.imageData) {
    payload.imageData = content.imageData;
  }

  if (content.videoUrl) {
    payload.videoUrl = content.videoUrl;
  }

  if (content.videoData) {
    payload.videoData = content.videoData;
  }

  if (content.linkUrl) {
    payload.linkUrl = content.linkUrl;
  }

  return JSON.stringify(payload);
};

export const normalizeExternalLink = (value?: string | null): string => {
  if (!value) {
    return '';
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return `https://${trimmed}`;
};

export const sanitizeHtmlContent = (html?: string | null): string => {
  if (!html) {
    return '';
  }
  let sanitized = html;
  sanitized = sanitized.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
  sanitized = sanitized.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '');
  sanitized = sanitized.replace(/\son[a-z]+\s*=\s*(['"]).*?\1/gi, '');
  sanitized = sanitized.replace(/\sstyle=['"].*?['"]/gi, '');
  sanitized = sanitized.replace(/javascript:/gi, '');
  sanitized = sanitized.replace(
    /<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>|<\/?span[^>]*>|<\/?strong>|<\/?em>|<\/?u>)*<\/p>/gi,
    ''
  );
  return sanitized;
};

export const stripHtmlTags = (html?: string | null): string => {
  if (!html) {
    return '';
  }
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};
